export * from "./client";
export * from "./useQueryParams";
export * from "./editOrgForm";
export * from "./common";
export * from "./assetForm";
export const sliceToChunk = (array = [], chunkSize = 5) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, chunkSize + i);
    result.push(chunk);
  }
  return result;
};